import { axiosGetAuthorize, axiosGetMultiParams, axiosPostAuthorize } from '../AxiosRequests';
import {
    GetExtraAdminLoginList,
    AddEditAdminLogin,
    DeleteAdminLogin,
    GetExtraUserLoginList,
    AddEditUser,
    DeleteUser,
    GetExtraHODList,
    AddEditHOD,
    DeleteHOD,
    GetAllRoleCategory,
    AddEditRole,
    RoleDelete
} from '../ApiEndPoints';

export default class UserServices {

    // Admin master
    async procSelectAll_AdminLogin(request) {
        return axiosGetAuthorize(GetExtraAdminLoginList, request);
    }
    async procInsertUpdate_AdminLogin(request) {
        return axiosPostAuthorize(AddEditAdminLogin, request);
    }
    async procDelete_AdminLogin(request) {
        return axiosGetAuthorize(DeleteAdminLogin, request);
    }

    // User Login Methods
    async procSelectAll_UserLogin(request) {
        return axiosGetAuthorize(GetExtraUserLoginList, request);
    }
    async procInsertUpdate_UserLogin(request) {
        return axiosPostAuthorize(AddEditUser, request);
    }
    async procDelete_UserLogin(request) {
        return axiosGetAuthorize(DeleteUser, request);
    }

    // HOD Login Methods
    async procSelectAll_HODLogin(request) {
        return axiosGetAuthorize(GetExtraHODList, request);
    }
    async procInsertUpdate_HODLogin(request) {
        return axiosPostAuthorize(AddEditHOD, request);
    }
    async procDelete_HODLogin(request) {
        return axiosGetAuthorize(DeleteHOD, request);
    }

    // Role
    async getAllRoleCategory() {
        return axiosGetAuthorize(GetAllRoleCategory);
    }
    async addEditRole(request) {
        return axiosPostAuthorize(AddEditRole, request);
    }
    async roleDelete(request) {
        return axiosGetAuthorize(RoleDelete, request);
    }
}